import { instance, ServiceResponse } from './Axios';

export const getUsers = async (params: {
  page: number;
  count: number;
  fullname?: string;
  email?: string;
  role?: string;
  roles?: string[];
}) => {

  const searchParams = new URLSearchParams({
    page: params.page.toString(),
    count: params.count.toString(),
    fullname: params.fullname ?? '',
    email: params.email ?? '',
    role: params.role ?? ''
  });

  if (params.roles) {
    params.roles.forEach((role) => searchParams.append('roles', role));
  }

  const url = `/users?${searchParams.toString()}`;

  const response = await instance.get<ServiceResponse<User[]>>(url);
  return response.data;
};